function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M0.051,7.66l6.087-0.039v15.357H0.051V7.66z M3.082-0.001C1.384-0.004,0.005,1.369,0,3.068v0.001 c0.005,1.697,1.385,3.068,3.082,3.063c0.001,0,0.001,0,0.001,0C4.78,6.137,6.16,4.765,6.164,3.068 C6.16,1.369,4.78-0.004,3.082-0.001z M18.743,7.03c-3.76,0-4.76,2.52-4.76,2.52l0.039-1.928H9.234L9.153,22.959h4.95v-9.408 c0.265-1.362,1.453-2.349,2.841-2.36c1.393,0.03,2.543,1.097,2.678,2.483v9.285l4.902-0.002V13.23 C24.207,9.191,22.503,7.03,18.743,7.03z"
});

var SvgIconIn = function SvgIconIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24.523px",
    height: "22.979px",
    viewBox: "0 0 24.523 22.979",
    enableBackground: "new 0 0 24.523 22.979",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-in.9575e1fe.svg";
export { ForwardRef as ReactComponent };